import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import { CloseIcon, NewDownloadIcon } from "../../../assets/images";
import {
  ImageDataType,
  SingleUploadImageDataType,
} from "../../../commonTypes/fileManagerTypes";
// import "./Files.scss";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { GetGenerateSasTokenPayloadType } from "../../../commonTypes/stcoToolsType";
import {
  getTokenGenerateForDownloadAction,
  resetSasTokenForDownloadFile,
} from "../../../redux/stcoTools";
import PdfPreviewWithApi from "../MultiPreviewWithApi/PdfPreviewWithApi";

type AppProps = {
  type?: string;
  token: null | string;
  clientCode?:number|null;
  resetImageUrl: () => void;
  imageDetails: SingleUploadImageDataType;
  sasTokenForDownloadFile: string;
  sasTokenForDownloadFetching: boolean;
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => void;
  dispatchResetSasTokenForDownloadFile: () => void;
};

const SinglePreviewWithApi = ({
  type,
  token,
  imageDetails,
  clientCode,
  resetImageUrl,
  sasTokenForDownloadFile,
  sasTokenForDownloadFetching,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
}: AppProps) => {
  const [previewUrl, setPreviewUrl] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  let isAutoDownload = useRef<boolean>(false);
  useEffect(() => {
    const downloadFile = async () => {
      if (sasTokenForDownloadFile && isAutoDownload?.current) {
        try {
          const response = await fetch(sasTokenForDownloadFile);
          if (!response.ok) {
            throw new Error("Failed to fetch file");
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = imageDetails?.finalFileName || "downloadFile";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          dispatchResetSasTokenForDownloadFile();
          isAutoDownload.current = false;
        } catch (error) {}
      }
    };
    downloadFile();
  }, [sasTokenForDownloadFile]);

  useEffect(() => {
    if (sasTokenForDownloadFile) {
      setPreviewUrl(sasTokenForDownloadFile);
    }
  }, [sasTokenForDownloadFile]);

  const handleDownload = () => {
    dispatchResetSasTokenForDownloadFile();
    let finalData = {
      token,
      fileUrl: imageDetails?.fileUrl,
      containerType: type === "finaccrm" ? 2 : type ==="client" ? 5  : 4,
      clientCode
    };
    dispatchGetTokenGenerateForDownloadAction(finalData);
    isAutoDownload.current = true;
  };

  useEffect(() => {
    const fetchPreviewUrl = async () => {
      setLoading(true);
      try {
        let finalData = {
          token,
          fileUrl: imageDetails?.fileUrl,
          containerType: type === "finaccrm" ? 2 : type ==="client" ? 5  : 4,
          clientCode
        };
        dispatchGetTokenGenerateForDownloadAction(finalData);
      } catch (error) {
        setPreviewUrl(null);
      } finally {
        setLoading(false);
      }
    };
    fetchPreviewUrl();
  }, []);

  return (
    <Modal isOpen={!!imageDetails?.fileUrl?.length} size="lg">
      <div
        className="pt-4,pl-4"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: `20px 20px ${
            imageDetails?.fileType === "application/pdf" ? "5px" : "20px"
          } 20px`,
        }}
      >
        <div>
          <h4 className="header">
            {imageDetails?.finalFileName &&
            imageDetails?.finalFileName?.length > 40
              ? imageDetails?.finalFileName.slice(0, 40) + "..."
              : imageDetails?.finalFileName}
          </h4>
          {/* <h6 className="bottom-header">
            {imageDetails?.updateBy ? imageDetails?.updateBy : ""}{" "}
            {imageDetails?.updatedAt ? imageDetails?.updatedAt : ""}
          </h6> */}
        </div>

        <div style={{ display: "flex", gap: "25px", alignItems: "center" }}>
          <button className="btn btn-primary" onClick={handleDownload}>
            <span className="pr-2">
              <img src={NewDownloadIcon} alt="download" />
            </span>
            Download
          </button>
          {/* )} */}
          <span
            onClick={resetImageUrl}
            style={{ cursor: "pointer", border: "none" }}
          >
            <img src={CloseIcon} alt="download" />
          </span>
        </div>
      </div>

      <ModalBody style={{ padding: 0, minHeight: "70vh" }}>
        {imageDetails?.fileType === "application/msword" ||
        imageDetails?.fileType === "application/vnd.ms-excel" ||
        imageDetails?.fileType ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        imageDetails?.fileType ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        imageDetails?.fileType ===
          "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
        imageDetails?.fileType === "application/vnd.ms-powerpoint" ? (
          previewUrl && (
            // eslint-disable-next-line
            <iframe
              src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                previewUrl
              )}`}
              width="100%"
              height="400px"
            />
          )
        ) : imageDetails?.fileType === "application/pdf" ? (
          <PdfPreviewWithApi imageDetails={previewUrl} />
        ) : (
          <img width="100%" height="450px" src={previewUrl} />
        )}
      </ModalBody>
    </Modal>
  );
};
const mapStateToProps = (state: RootState) => ({
  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  sasTokenForDownloadFetching: state.stcoTools.sasTokenForDownloadFetching,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetTokenGenerateForDownloadAction: (
    data: GetGenerateSasTokenPayloadType
  ) => dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SinglePreviewWithApi);
